import { useRouter, useSearchInput as useSearchInputGeneral } from '@application/utils';
import type { InputSelectData, SelectOption } from '@presentation/components';
import { useCallback, useEffect, useState } from 'react';
import { useGetAllBreeds } from './api/useGetAllBreeds';

export const useSearchInput = () => {
  const { navigateToRoute } = useRouter();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectOptions, setSelectOptions] = useState<SelectOption<string>[]>([]);
  const searchInput = useSearchInputGeneral({});

  const { breedListOptionsWithImages, breedsLoading } = useGetAllBreeds();

  useEffect(() => {
    if (searchInput?.search) {
      setLoading(true);
      const options = breedListOptionsWithImages?.filter((item) => {
        return item.searchValues?.some((element) =>
          element.toLowerCase().includes(String(searchInput.search).toLowerCase()),
        );
      });
      setSelectOptions(options);
      setLoading(false);
    } else {
      setSelectOptions([]);
    }
  }, [breedListOptionsWithImages, searchInput.search]);

  const onSelectHandler = useCallback(
    (selected: SelectOption<string> | undefined) => {
      if (selected?.value) {
        navigateToRoute('breed', { params: [selected.value] });
      }
    },
    [navigateToRoute],
  );

  return {
    ...searchInput,
    loading: loading || breedsLoading,
    onSelect: onSelectHandler,
    selectOptions,
  } as InputSelectData<string>;
};
